import React from 'react';
import "./style.sass";

export function HeaderMobileSolicitud({ titulo, totalItems, posicion }) {
    return (
        <>
            <div className="headerSolicitud">
                <div className="div1">
                    <p>{titulo}</p>
                </div>
                <div className="div2">
                    <p>{posicion} de {totalItems}</p>
                </div>
            </div>

        </>
    )
}